import { api } from '@/api/client';
import type { SuperadminWebhookApiResponse } from '../pages/webhooks/types';

// Superadmin Webhooks Service
export const superadminWebhooksService = {
  /**
   * Get webhooks list with pagination and filters
   */
  async list(
    page: number = 1,
    pageSize: number = 15,
    filters?: {
      transaction_id?: string;
      merchant_transaction_id?: string;
      transaction_status?: string;
      start_date?: string;
      end_date?: string;
      merchant_uuid?: string;
      webhook_status?: string;
    }
  ): Promise<SuperadminWebhookApiResponse> {
    // const params = new URLSearchParams({
    //   page: page.toString(),
    //   page_size: pageSize.toString(),
    // });

    const params = new URLSearchParams();

    // Add filters if provided
    if (filters?.transaction_id && filters.transaction_id.trim()) {
      params.append('transaction_id', filters.transaction_id.trim());
    }

    if (filters?.merchant_transaction_id && filters.merchant_transaction_id.trim()) {
      params.append('merchant_transaction_id', filters.merchant_transaction_id.trim());
    }

    if (filters?.transaction_status && filters.transaction_status.trim()) {
      params.append('transaction_status', filters.transaction_status.trim());
    }

    if (filters?.webhook_status && filters.webhook_status.trim()) {
      params.append('webhook_status', filters.webhook_status.trim());
    }

    if (filters?.merchant_uuid) {
      params.append('merchant_uuid', filters.merchant_uuid);
    }
    const response = await api.get<SuperadminWebhookApiResponse>(
      `/backoffice/api/v1/webhooks/?${params.toString()}`
    );
    return response as unknown as SuperadminWebhookApiResponse;
  },

  /**
   * Get webhook by ID
   */
  async getById(webhookId: string): Promise<SuperadminWebhookApiResponse> {
    const response = await api.get<SuperadminWebhookApiResponse>(
      `/backoffice/api/v1/webhooks/${webhookId}/`
    );
    return response as unknown as SuperadminWebhookApiResponse;
  },

  /**
   * Retry webhook
   */
  async retry(webhookId: string): Promise<any> {
    const response = await api.post(`/backoffice/api/v1/webhooks/${webhookId}/retry/`);
    return response;
  },

  async listMerchants() {
    return api.get('/backoffice/api/v1/merchants/');
  },
};
